import { FileListItem } from "./FileListItem";
import { MultiuploadResult } from "./MultiuploadResult";
import { PicturePack } from "./PicturePack";


export class OnlineStorage
{
    constructor(public url: string, private authToken: string) 
    { }

    public async GetDir(dir: string = ""): Promise<FileListItem[]>
    {
        const response = await fetch(this.url + "/list/" + dir);
        const list = await response.json() as FileListItem[];
        return list;
    }

    public async GetFiles(dir: string = ""): Promise<PicturePack[]>
    {
        const items = await this.GetDir(dir);

        const files = items.filter(x => x.Type === "file");

        const filesNames = files.map(x => x.Name);

        return this.NamesToPicturePacks(filesNames, dir);
    }

    private ToFullUrl(dir: string, file: string): string
    {
        return this.url + "/pic/" + dir + "/" + file;
    }

    private NamesToPicturePacks(fileNames: string[], dir: string): PicturePack[]
    {
        const map = new Map();

        fileNames.forEach(file =>
        {
            const match = file.match(/^(.+?)\.(original|normalized|thumbnail|mini)\.(\w+)$/);
            if (match)
            {
                const [_, baseName, type, extension] = match;

                if (!map.has(baseName))
                {
                    map.set(baseName, new PicturePack(baseName, extension));
                }

                const pack = map.get(baseName);

                switch (type)
                {
                    case "original":
                        pack.Original = this.ToFullUrl(dir, file);
                        break;
                    case "normalized":
                        pack.Normalized = this.ToFullUrl(dir, file);
                        break;
                    case "thumbnail":
                        pack.Thumbnail = this.ToFullUrl(dir, file);
                        break;
                    case "mini":
                        pack.Mini = this.ToFullUrl(dir, file);
                        break;
                }
            }
        });

        return Array.from(map.values());
    }

    public async UploadManyFiles(files: File[], dir: string = ""): Promise<MultiuploadResult>
    {
        try
        {
            if (!files)
            {
                return MultiuploadResult.Failure("No files provided");
            }

            const formData = new FormData();

            for (let i = 0; i < files.length; i++)
            {
                formData.append('files[]', files[i]); // Tak, te [] w nazwie zmiennej są konieczne! bez tego php (mimo że odbiera przez $_FILES["files"]) nie jest w stanie odebrać wielu plików xd
            }
            formData.append('folder', dir.trim());
            formData.append('auth-token', this.authToken);

            const response = await fetch(this.url + "/multiupload", {
                method: 'POST',
                body: formData,
            });

            if (!response.ok)
            {
                return MultiuploadResult.Failure(`Request failed with status ${response.status}`);
            }

            const filesNames = await response.json();

            return MultiuploadResult.Success(filesNames);
        }
        catch (ex: any)
        {
            return MultiuploadResult.Failure(`Can not upload: ${ex.message}`);
        }
    }

    public async Delete(dir: string, nameOnly: string)
    {
        const response = await fetch(this.url + "/delete/" + dir + "/" + nameOnly);

        const result = await response.json();

        return result.success;
    }
}
